import { Box, FormControl } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useFetchOrganizations } from '../../hooks/useFetchOrganizations'
import SearchInAPIAndMultiSelectInput from './SearchInAPIAndMultiSelectInput'
import { IListItemValue } from '../../interfaces/Interfaces'
import { ReactElement } from 'react'

interface OrganizationMultiSelectFieldProps {
    label: string
    id: string
    value: IListItemValue[]
    onChange: any
    errorMessage?: string
    required?: boolean
    disabled?: boolean
    excludeOrgs?: string[]
}

const OrganizationMultiSelectField = (
    props: OrganizationMultiSelectFieldProps,
): ReactElement => {
    const {
        label,
        id,
        value = [],
        onChange,
        errorMessage,
        required,
        disabled,
        excludeOrgs,
    } = props
    const { t } = useTranslation()

    const { orgsList, isFetching, hasMore, onSearch, fetchNextPage } =
        useFetchOrganizations({ excludeOrgs })

    const onSelect = (id: string, val: any) => {
        onChange(id, val)
    }
    return (
        <Box>
            <Box>
                <FormControl fullWidth disabled={!!disabled} size="small">
                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Box
                            sx={{
                                width: ' 100%',
                                maxWidth: `100%`,
                            }}
                        >
                            <SearchInAPIAndMultiSelectInput
                                id={id}
                                label={label}
                                placeholder={t('selectLabel', { label })}
                                required={required}
                                value={value}
                                onSelect={onSelect}
                                list={orgsList}
                                errorMessage={
                                    !value?.length && errorMessage
                                        ? errorMessage
                                        : ''
                                }
                                disabled={disabled}
                                onSearch={onSearch}
                                onFetchNextPage={fetchNextPage}
                                hasMore={hasMore}
                                isFetching={isFetching}
                            />
                        </Box>
                    </Box>
                </FormControl>
            </Box>
        </Box>
    )
}

export default OrganizationMultiSelectField
